import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TerritoryConfigUpdatePayload } from '../models/territory-config-update.model';
import { UpdateJobType } from '../models/job-type.model';

@Injectable({
    providedIn: 'root'
})
export class TerritoryService {
    constructor(private http: HttpClient) {}

    getTerritoryConfig() {
        return this.http.get<any>( `${environment.appOrgUrl}TerritoryManagementConfig`);
    }

    updateTerritoryConfig(territoryConfigData: TerritoryConfigUpdatePayload) {
        return this.http.put<any>(`${environment.appOrgUrl}TerritoryManagementConfig`, territoryConfigData);
    }

    getJobFunctionLists() {
        return this.http.get<any>( `${environment.appOrgUrl}JobType`);
    }

    updateJobFunctions(jobFunctionData: UpdateJobType[]) {
        return this.http.post<any>(`${environment.appOrgUrl}TerritoryManagementConfig/JobTypeConfig`, jobFunctionData);
    }
}